'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'deer';
var width = 576;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = ['M88 264l0 14.1c19.6 19.6 30.3 30.3 32 32l0 45.8-1.2 3.7-13.4 40.1 23.4 64.3 28.9 0c-15.9-43.8-24.7-67.8-26.2-72 6-4.8 20.9-16.7 44.4-35.6l0-53.8c18.9 6.3 44.2 14.7 75.9 25.3l92.1 0 0 136 32 0 0-152.2c0-7.7 1.2-15.4 3.7-22.8 17-51.1 26-78.1 27-81l97.3 0 0-29.4-73.3-66.6-36.9 0-26 86.9-5.1 17.1-226.8 0c-26.5 0-48 21.5-48 48zM448 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M288 16l0-16-32 0 0 40c0 30.9 25.1 56 56 56l36.6 0-.3 .9-60.3 15.1 0 32 46.2 0-7.2 24-191 0c-28.5 0-54.2 12.5-71.8 32.2-19.8 17.6-32.2 43.2-32.2 71.8l0 64 32 0 0-14.1 8 8 0 18.2-14.8 44.3-2.6 7.9 2.9 7.9 32 88 5.7 15.8 131.1 0c-5.4-14.9-18-49.5-37.8-104 20.6-16.5 32.5-26 35.6-28.4l0-10.2 16.4 5.5 3.7 1.2 51.9 0 0 136 128 0 0-200.2c0-2.6 .4-5.1 1.2-7.6l16.1-48.2 110.7 0 0-98.6-7.9-7.1-68-61.8C492.8 78.7 504 60.7 504 40l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-69.4 0c3.5-7.3 5.4-15.4 5.4-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24zM176 356.5c-23.6 18.9-38.4 30.7-44.4 35.6 1.5 4.2 10.2 28.2 26.2 72l-28.9 0-23.4-64.3 13.4-40.1 1.2-3.7 0-45.8c-1.7-1.7-12.4-12.4-32-32L88 264c0-26.5 21.5-48 48-48l226.8 0 5.1-17.1 26-86.9 36.9 0 73.3 66.6 0 29.4-97.3 0c-1 2.9-10 29.9-27 81-2.4 7.3-3.7 15-3.7 22.8l0 152.2-32 0 0-136-92.1 0c-31.7-10.6-57-19-75.9-25.3l0 53.8zM448 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;